import Tabs from "./routerTabs";
import Tab from "./routerTab";

export { Tab, Tabs };
export default {
  Tab,
  Tabs,
};
